import { default as sanitizeHtml, IOptions } from "sanitize-html"
import MathMLScheme from "./mathml-tags"
import SvgScheme from "./svg-tags"
import { flatten, hasText } from "utils/helpers"
import { useMemo } from "react"

export const QuillSanitationScheme: IOptions = {
  allowedTags: flatten(Object.keys(MathMLScheme), Object.keys(SvgScheme), [
    "span",
    "b",
    "strong",
    "i",
    "em",
    "s",
    "del",
    "u",
  ]),
  allowedAttributes: false /*{
    ...MathMLScheme,
    ...SvgScheme,
    'span': ['ql-formula', 'data-value', 'contenteditable', 'class',
      'style','aria-hidden'
    ]
  },*/,
  disallowedTagsMode: "discard",
}

export const QuilLongTextScheme: IOptions = {
  allowedTags: flatten(Object.keys(MathMLScheme), Object.keys(SvgScheme), [
    "span",
    "p",
    "br",
    "b",
    "strong",
    "i",
    "em",
    "s",
    "del",
    "u",
  ]),
  allowedAttributes: false /*{
    ...MathMLScheme,
    ...SvgScheme,
    'span': ['ql-formula', 'data-value', 'contenteditable', 'class',
      'style','aria-hidden'
    ]
  },*/,
  disallowedTagsMode: "discard",
}

// console.log('QuillSanitationScheme', QuillSanitationScheme)

export function extractEditorPreviewScreenTooltip(
  input: string,
  defaultText: string
): string {
  const sanitized = sanitizeHtml(input, {
    allowedTags: ["span"],
    allowedAttributes: {},
    disallowedTagsMode: "discard",
  })

  const node = document.createElement("div")
  node.innerHTML = sanitized
  const text = node.innerText

  if (text.length > 0) {
    //console.log(text)
    return text
  } else {
    return defaultText
  }
}

export function sanitizeEditorTextHtml(
  input: string | null | undefined
): string {
  if (!hasText(input)) return input || ""

  let sanitized = sanitizeHtml(input!, QuilLongTextScheme)
  sanitized = sanitized.replace("<p></p>", "<br />")
  //console.log({input, sanitized})
  return sanitized
}

export function sanitizeEditorPreviewHtml(
  input: string | undefined | null
): string {
  if (!input) return ""

  return sanitizeHtml(input, QuillSanitationScheme)
}

export function extractEditorPreviewScreenHtml(
  input: string,
  defaultText: string
): string {
  const dirty = input
  const sanitized = sanitizeEditorPreviewHtml(dirty)

  const node = document.createElement("div")
  node.innerHTML = sanitized

  const hasText = node.innerText.length > 0
  node.remove()

  if (hasText) {
    return sanitized
  } else {
    return defaultText
  }
}

/**
 * Return a cached, sanitized html
 * @param input string|null|undefined
 * @return Sanitized input.
 * null if there is no text in the rendered HTML
 */
export function useHtmlSanitization(
  input: string | null | undefined
): string | null {
  const result = useMemo(() => {
    if (!hasText(input)) {
      return null
    }

    const sanitizedRaw = sanitizeEditorTextHtml(input!)

    const div = document.createElement("div")
    div.innerHTML = sanitizedRaw
    const justText = div.innerText
    if (!hasText(justText.trim())) {
      return null
    }

    return sanitizedRaw
  }, [input])

  return result
}
